namespace Areas {
    "use strict";

    export function addResetLayout(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        addButtonToToolbar(e.toolbarOptions, {
            text: "Reset Layout",
            hint: "Reset grid layout",
            type: "normal",
            icon: "revert",
            onClick: reset(grid)
        }, "after");
    }

    function reset(grid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            grid.state({});
        }
    }
}